import { render, staticRenderFns } from "./ApproveRejectDisburse.vue?vue&type=template&id=15f1b204"
import script from "./ApproveRejectDisburse.vue?vue&type=script&lang=js"
export * from "./ApproveRejectDisburse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports